export default __webpack_public_path__ + "static/media/12t.658645d2.jpg";